const no = {
  translation: {
    salutation: "hei der",
    introduction: "jeg er",
    introudction_job_title: "og jeg er en",
    developer: "utvikler",
    download: "last ned",
    cv: "CV",
    select: "velg",
    experiance_years: "{{years}} år",
    of_experiance: "av erfaring",
    my_portofolio: "min portefølje",
    portofolio: "portefølje",
    testimonials: "attester",
    all: "alle",
    about: "om",
    skill_level_question: "hva er mitt ferdighetsnivå",
    see_more: "se mer",
    achievements: "prestasjoner",
    personal_info: "Personlig info",
    experience: "Erfaring",
    education: "Utdanning",
    skills_and_technology: "ferdigheter og teknologi",
    hide: "skjul",
    get_in_touch: "kom i kontakt",
    send_message: "send melding",
    message: "melding",
    subject: "emne",
    your_name: "ditt navn",
    email_address: "e-postadresse",
    talk_statment: "la oss snakke om alt",
    like_form_question: "liker ikke skjemaer",
    send_me: "send meg en",
    email: "e-post",
    language: "språk",
    home_page: "hjemmeside",
    me: "meg",
    my_experience: "min erfaring",
    coming_soon: "kommer snart",
    this_page_is_under_construction: "denne siden er under konstruksjon",
    is_required_field: "{{field}} er et påkrevd felt",
  },
};

export default no;
